module.exports = __webpack_public_path__ + "static/img/submit-request.825ee0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/submit-request.svg
// module id = O1fp
// module chunks = 0